import scrollparent from 'scrollparent';

export function getClosestScrollParent(node) {
  return scrollparent(node);
}

export const defaultRender = () => {
  return null;
};